export const thesisTypes = [
  { code: 'PHD', name: 'PhD' },
  { code: 'MPHIL_IN_LIEU_OF_PHD', name: 'MPhil in lieu of PhD' },
  { code: 'MPHIL', name: 'MPhil' },
  { code: 'PROFESSIONAL_DOCTORATE', name: 'Professional Doctorate' },
]
